import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // Check if user has already given consent
    const hasConsented = localStorage.getItem('cookieConsent');
    if (!hasConsented) {
      // Show consent after a small delay for better UX
      setTimeout(() => {
        setShowConsent(true);
      }, 1000);
    }
  }, []);

  const handleAccept = () => {
    // Save consent to localStorage
    localStorage.setItem('cookieConsent', 'true');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    
    // Set analytics cookies
    setCookies();
    
    // Hide the consent modal
    setShowConsent(false);
  };

  const setCookies = () => {
    // Set essential cookies for site functionality
    document.cookie = "site_functionality=enabled; path=/; max-age=31536000; SameSite=Lax";
    
    // Set analytics cookies (you can integrate Google Analytics here later)
    document.cookie = "analytics_enabled=true; path=/; max-age=31536000; SameSite=Lax";
    
    // Set user preferences
    document.cookie = "user_preferences=enabled; path=/; max-age=31536000; SameSite=Lax";
    
    console.log("✅ Cookies установлены для аналитики и улучшения работы сайта");
  };

  if (!showConsent) {
    return null;
  }

  return (
    <>
      {/* Mobile overlay (center) */}
      <div className="d-block d-sm-none position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ zIndex: 1050, backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
        <div className="bg-dark text-white p-4 rounded-3 mx-3 shadow-lg" style={{ maxWidth: '350px' }}>
          <div className="mb-4">
            <h3 className="h5 fw-semibold mb-3 text-white">
              Мы используем cookies для более удобной работы с сайтом и сбора статистики.
            </h3>
            <p className="text-light small mb-3">
              Подробнее можно почитать в{" "}
              <Link 
                to="/cookie-policy" 
                className="text-info text-decoration-underline"
                onClick={() => setShowConsent(false)}
              >
                Политике cookies
              </Link>
              . Оставаясь на сайте, вы соглашаетесь на применение cookies
            </p>
          </div>
          
          <button
            onClick={handleAccept}
            className="btn btn-primary w-100 fw-semibold py-2 px-3 rounded-3"
          >
            Соглашаюсь
          </button>
        </div>
      </div>

      {/* Desktop position (bottom left) */}
      <div className="d-none d-sm-block position-fixed bottom-0 start-0 m-3" style={{ zIndex: 1050, maxWidth: '400px' }}>
        <div className="bg-dark p-4 rounded-3 shadow-lg">
          <div className="mb-3">
            <h3 className="fs-lg mb-3 text-white">
              Мы используем cookies для более удобной работы с сайтом и сбора статистики.
            </h3>
            <p className="text-light small mb-3">
              Подробнее можно почитать в{" "}
              <Link 
                to="/cookie-policy" 
                className="text-info text-decoration-underline"
                onClick={() => setShowConsent(false)}
              >
                Политике cookies
              </Link>
              . Оставаясь на сайте, вы соглашаетесь на применение cookies
            </p>
          </div>
          
          <button
            onClick={handleAccept}
            className="btn btn-primary w-100 fw-semibold py-2 px-3 rounded-3"
          >
            Соглашаюсь
          </button>
        </div>
      </div>
    </>
  );
};

export default CookieConsent;